export type { ToastOptions as NotifyOptions, ToastID } from "vue-toastification/dist/types/types";
import { defineStore, acceptHMRUpdate } from 'pinia';
import { useToast } from "vue-toastification";
import type { ToastID } from "vue-toastification/dist/types/types";
type PlayerToastIds = {
  info: ToastID | undefined;
  warning: ToastID | undefined;
  error: ToastID | undefined;
}

export const useNotifyStore = defineStore('notifications', () => {

  const toast = useToast();
  const playerToastIds: PlayerToastIds = {
    // first toast after F5 gets an id of 0, which is unfortunate
    info: undefined,
    warning: undefined,
    error: undefined,
  };

  return {
    toast,
    playerToastIds,
    // notifications: toast,
    clear: toast.clear,
    dismiss: toast.dismiss,
    update: toast.update,
    success: toast.success,
    info: toast.info,
    error: toast.error,
    warning: toast.warning,
  };
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useNotifyStore, import.meta.hot))
}
